import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";
import Content from "components/Content/index";
export default function () {
  const { slug, id } = useParams();
  return <Content slug={slug} id={id} />;
}
